import { setCsrfToken } from "../api";
import { useUserContext } from "../contexts";
import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import Form from "./Form";
import Spacer from "./Spacer";
import AuthLayout from "./AuthLayout";

export default function Login() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { user } = useUserContext();

  function handleLogin(data) {
    // Set CSRF token and update user in queryClient
    if (data && data.csrfToken && data.user) {
      setCsrfToken(data.csrfToken);
      queryClient.setQueryData(["user"], data.user);
    }
  }

  useEffect(
    function handleRedirect() {
      if (user !== null) {
        const next = new URL(document.location).searchParams.get("next");
        if (next) {
          navigate(next);
        } else {
          navigate("/");
        }
      }
    },
    [user] // eslint-disable-line react-hooks/exhaustive-deps
  );

  const fields = [
    {
      name: "Email",
      id: "username",
      type: "text",
      required: true,
    },
    {
      name: "Password",
      id: "password",
      type: "password",
      required: true,
    },
  ];

  return (
    <AuthLayout heading="Sign in to your account">
      <Form
        path="login"
        fields={fields}
        submitCallback={handleLogin}
        updateCache={false}
        submitText="Log in"
      />
      <Spacer size="large" />
      <Link to="/signup" className="hover:underline text-sm text-center block">
        Don&apos;t have an account? Sign up
      </Link>
    </AuthLayout>
  );
}
